import { ActivatedRouteSnapshot } from '@angular/router';
import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import { LoggingService } from '../../shared/services/core/logging.service';
import { RegistrationStepService } from './registration-step.service';
import { RegistrationStepQuery } from './registration-step.query';
import { StepType } from '../models/step-type';
import { mapTo } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class RegistrationStepResolver {
  constructor(
    private registrationStepQuery: RegistrationStepQuery,
    private registrationStepService: RegistrationStepService,
    private logService: LoggingService
  ) {}

  resolve(route: ActivatedRouteSnapshot) {
    if (this.registrationStepQuery.getValue().wizardType === undefined) {
      // Haven't gone through a registration entry point yet in this session
      const currentStepType = this.getCurrentStepType(route);
      this.logService.info('Fetching current registration data from the API...', currentStepType);
      return this.registrationStepService.fetchRegistrationStepsForCurrentWizard(currentStepType);
    } else {
      // Continuing an already started registration process so do nothing
      this.logService.debug('Registration process already in progress, skipping syncing of registration data with the API.');
      return of(null).pipe(mapTo(null));
    }
  }

  /** Gets the current step type from the current route. */
  private getCurrentStepType(route: ActivatedRouteSnapshot): StepType | undefined {
    return route.firstChild ? route.firstChild.data.registrationStep : undefined;
  }
}
